export default __webpack_public_path__ + "static/media/p15.d2de3175.jpg";